class LoginController {
  /* @ngInject */

  constructor($rootScope, $state, $log, LoginService, StoreService, $filter) {
    const that = this;
    that.user = {
      name: '',
      password: ''
    };
    that.userTypeError = false;
    that.error = undefined;
    that.loading = false;

    that.login = () => {
      that.userTypeError = false;
      that.error = undefined;
      that.loading = true;
      LoginService.login(this.user.name, this.user.password).then(
        () => {
          StoreService.getBusinesses().then(() => {
            $rootScope.$broadcast("$businessesChangeSuccess");
          })
          StoreService.getStoreList().then(() => {
            $rootScope.$broadcast("$storeChangeSuccess");
            that.onLoginCompleted();
          })
        }, (reason) => {

          $log.error('LoginController', 'login', reason);
          that.userTypeError = true;
          that.error = $filter('translate')(reason);

        }).finally(
        () => {
          that.loading = false;
        }
      );
    };

    const deregLogin = $rootScope.$on('USER_LOG_ERROR', () => {
      console.log("Inside event login error")
      that.userTypeError = true;
      that.error = $filter('translate')('login.errors.merchant');
      that.loading = false;
    });
  }
}

export default LoginController;



/** WEBPACK FOOTER **
 ** ./client/app/components/login/login.controller.js
 **/